import React, { useState } from 'react';
import MetaTags from 'components/common/MetaTags';
import PageHeader from 'components/NewDesign/PageHeader';
import MainContent from 'components/NewDesign/MainContent';
import MostMeetPRs from 'components/admin/reports/MostMeetPRs';
import { exportMostMeetPRsReportToFile } from 'api/reportsApi';
import { useSelector } from 'react-redux';
import CustomNewButton from 'components/NewDesign/CustomNewButton';
import { exportAndDownloadFile } from 'utils/fileDownload';

const MostMeetPRsPage = () => {
  const { selectedClub } = useSelector((state) => state.user || {});
  const [reportData, setReportData] = useState(null);

  const handleExportToFile = async () => {
    await exportAndDownloadFile(
      exportMostMeetPRsReportToFile,
      [selectedClub.clubID, reportData?.minPRsBeaten || 2],
      '',
      'The best meet performance report was successfully exported',
      'Fetching best meet performance data from the server...'
    );
  };

  const isExportButtonDisabled = !reportData || !reportData.hasData;

  return (
    <>
      <MetaTags title="SplitFast | Best Meet Performance Report" />
      <MainContent>
        <PageHeader
          title="Best Meet Performance Report"
          subTitle={reportData?.seasonName || ''}
          primarySubTitle
        >
          <CustomNewButton
            variant="info"
            onClick={handleExportToFile}
            label="Export to file"
            disabled={isExportButtonDisabled}
          />
        </PageHeader>
        {!selectedClub ? (
          <div style={{ minHeight: '100vh' }}/>
        ) : (
          <MostMeetPRs
            clubID={selectedClub?.clubID}
            onDataChange={setReportData}
          />
        )}
      </MainContent>
    </>
  );
};

export default MostMeetPRsPage;
